import type { Loan } from '@taler/api-client'

/** A loan can be removed only before any payment, drawdown, or accrual creates history. */
export function canDeleteLoan(loan: Loan, hasHistory: boolean | undefined): boolean {
  return hasHistory === false && loan.accrualCount === 0
}
